import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean } from '../../../../Fct/generics';
export var IsApprovedForAll = createPlugin({
    protocol: 'ERC1155',
    type: 'GETTER',
    method: 'isApprovedForAll',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc1155', isPreview: true, }),
                methodParams: {
                    account: new FctAddress({}),
                    operator: new FctAddress({}),
                },
            },
            output: {
                isApproved: new FctBoolean({ innerIndex: 0 }),
            },
        });
    },
});
